<template>
  <div>
    <div class="condition-section">
      <div class="con-row">
        <div style="margin-right: 10px;margin-left: -5px">域名状态：</div>
        <div
          :class="['item', { active: item.value === searchObj.status }]"
          v-for="item in domainStatusList"
          :key="item.value"
          @click="onCheckDomainStatus(item.value)"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="cond-row">
        <div class="item">
          <div style="margin-right: 10px">域名：</div>
          <Input
            class="height45"
            v-model="domainName"
            placeholder="请输入搜索的域名名称"
            style="width: 300px"
            clearable
          />
        </div>
        <div class="item">
          <Button
            class="btn-height45"
            type="primary"
            style="margin-right: 20px"
            @click="onSearch"
            >搜索</Button
          >
          <Button class="btn-height45" @click="onSearchCancel">重置</Button>
        </div>
      </div>
    </div>
    <div class="table-data">
      <div class="total">发出的请求（{{ searchObj.total }}）</div>
      <Table
        class="domain-table"
        :columns="columns"
        :data="data"
        :loading="tableLoading"
      >
        <template slot="status" slot-scope="{ row }">
          {{ row.status | statusFilter }}
        </template>
        <template slot="result" slot-scope="{ row }">
          <div
            style="color: #2d8cf0; cursor: pointer"
            @click="onShowDomainList(row.resultList)"
          >
            {{ row.res }}
          </div>
        </template>
        <template slot="remark" slot-scope="{ row }">
          <Button @click="onShowRemark(row.remark)">查看备注</Button>
        </template>
        <template slot="action" slot-scope="{ row }">
          <Button v-if="row.status === 0" @click="onReject(row)">取消</Button>
          <div v-else>--</div>
        </template>
      </Table>
      <div class="page-tool">
        <Page
          :current="searchObj.page"
          :total="searchObj.total"
          :page-size="searchObj.limit"
          @on-change="onPageChange"
        />
      </div>
    </div>
    <!-- PUSH备注 -->
    <pushRemarkModal
      :show.sync="pushRemarkModalVisibility"
      :data="remark"
    ></pushRemarkModal>
    <!-- PUSH结果 -->
    <pushResultModal
      :show.sync="pushResultModalVisibility"
      :data="resultList"
    ></pushResultModal>
  </div>
</template>

<script>
import { pushPageList, pushEdit } from "api/domain.js";
import pushRemarkModal from "components/push/pushRemarkModal.vue";
import pushResultModal from "components/push/pushResultModal.vue";

export default {
  name: "pushSent",
  components: {
    pushRemarkModal,
    pushResultModal,
  },
  filters: {
    statusFilter(val) {
      let title = "";
      switch (val) {
        case 0:
          title = "未接收";
          break;
        case 1:
          title = "已接收";
          break;
        case 2:
          title = "已拒绝";
          break;
        case 3:
          title = "已取消";
          break;
        case 4:
          title = "未接收";
          break;
        default:
          break;
      }
      return title;
    },
  },
  data() {
    return {
      domainName: "",
      // 域名状态
      domainStatusList: [
        {
          name: "全部域名",
          value: -1,
        },
        {
          name: "未接收",
          value: 0,
        },
        {
          name: "已接收",
          value: 1,
        },
        {
          name: "已拒绝",
          value: 2,
        },
        {
          name: "已取消",
          value: 3,
        },
      ],
      columns: [
        {
          title: "域名",
          align: "center",
          key: "ym",
        },
        {
          title: "数量",
          align: "center",
          key: "count",
        },
        {
          title: "对方ID",
          align: "center",
          key: "recipient",
        },
        {
          title: "成功/失败/总数",
          align: "center",
          slot: "result",
        },
        {
          title: "索要金额",
          align: "center",
          key: "amount",
        },
        {
          title: "时间",
          align: "center",
          key: "createdTime",
        },
        {
          title: "状态",
          align: "center",
          slot: "status",
        },
        {
          title: "操作",
          align: "center",
          slot: "action",
        },
        {
          title: "备注",
          align: "center",
          slot: "remark",
        },
      ],
      data: [],
      tableLoading: false,
      searchObj: {
        status: -1,
        page: 1,
        limit: 10,
        total: 0,
      },
      remark: "",
      pushRemarkModalVisibility: false,
      resultList: [],
      pushResultModalVisibility: false,
    };
  },
  created() {
    this.req_getList();
  },
  methods: {
    onCheckDomainStatus(val) {
      this.searchObj.status = val;
      this.onPageChange(1);
    },
    // 请求
    async req_getList() {
      try {
        let params = {
          dn: this.domainName,
          page: this.searchObj.page,
          limit: this.searchObj.limit,
          type: 1,
        };
        if (this.searchObj.status !== -1) {
          params.status = this.searchObj.status;
        }
        this.tableLoading = true;
        const { code, data } = await pushPageList(params);
        this.tableLoading = false;
        if (code === 200) {
          this.data = data.list || [];
          this.searchObj.total = data.total;
        }
      } catch (error) {
        this.tableLoading = false;
        console.log(error);
      }
    },
    // 跳页
    onPageChange(val) {
      this.searchObj.page = val;
      this.req_getList();
    },
    // 搜索
    onSearch() {
      this.onPageChange(1);
    },
    // 重置
    onSearchCancel() {
      this.domainName = "";
      this.searchObj.status = -1;
      this.onPageChange(1);
    },
    // 查看备注
    onShowRemark(val) {
      this.pushRemarkModalVisibility = true;
      this.remark = val;
    },
    // 拒绝
    onReject(val) {
      this.$Modal.confirm({
        title: "提示",
        content: "<p>您确认取消push吗？</p>",
        onOk: async () => {
          try {
            const res = await pushEdit({
              id: val.id,
              status: 3,
            });
            if (res.code === 200) {
              this.$Message.success("操作成功!");
              this.req_getList();
            } else {
              this.$Message.warning("操作失败，稍后重试!");
            }
          } catch (error) {
            this.$Message.warning("操作失败，稍后重试!");
          }
        },
      });
    },
    // 查看域名
    onShowDomainList(val) {
      this.pushResultModalVisibility = true;
      this.resultList = val;
    },
  },
};
</script>

<style lang="less" scoped>
.con-row {
  display: flex;
  height: 40px;
  line-height: 40px;
  margin-bottom: 20px;
  .item {
      font-size: 14px;
      font-weight: 600;
      color: #434063;
      cursor: pointer;
      margin-right: 40px;
      background: #f5f9fe;
      border-radius: 54px;
      border: 1px solid #759de6;
      width: 100px;
      text-align: center;
      line-height: 40px;
    }
    .item.active {
      color: #FFF;
      background: #315491;
    }
}
.condition-section {
  margin: 15px;
  background-color: #fff;
  padding: 20px 20px;
  .cond-row {
    display: flex;
    flex-wrap: wrap;
    line-height: 60px;
    .item {
      display: flex;
      align-items: center;
      margin: 0 20px;
    }
  }
}

.row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  line-height: 60px;
  .name {
    min-width: 120px;
    text-align: right;
    margin-right: 20px;
  }
}

/deep/.height40 {
  .ivu-input {
    height: 40px;
    line-height: 40px;
  }
  .ivu-input-icon {
    line-height: 40px;
  }
  .ivu-input-with-prefix {
    padding-left: 40px;
  }
  .ivu-input-prefix {
    width: 60px;
    padding: 0 10px;
  }
  .ivu-select-selection {
    height: 40px;
  }
  .ivu-select-input {
    height: 40px;
  }
  .ivu-select-selected-value {
    height: 40px;
    line-height: 40px;
  }
  .ivu-select-placeholder {
    height: 40px;
    line-height: 40px;
  }
}
.table-data {
  margin: 40px 0;
  background-color: #fff;
  padding: 20px 20px;
  .total {
    margin-bottom: 20px;
  }
}
.page-tool {
  margin-top: 40px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
}
/deep/.domain-table {
  .ivu-table-header th {
    background-color: #315491;
  }
  .ivu-table-header th,
  .ivu-table-body td {
   height: 60px;
  }
  .ivu-table-tip {
    td {
      line-height: 300px;
    }
  }
}
</style>

<style lang="less" scoped>
/deep/.height45 {
  .ivu-input {
    height: 45px;
    line-height: 45px;
  }
  .ivu-input-icon {
    line-height: 45px;
  }
  .ivu-input-with-prefix {
    padding-left: 60px;
  }
  .ivu-input-prefix {
    width: 60px;
    padding: 0 10px;
  }
  .ivu-select-selection {
    height: 45px;
  }
  .ivu-select-input {
    height: 45px;
  }
  .ivu-select-selected-value {
    height: 45px;
    line-height: 45px;
  }
  .ivu-select-placeholder {
    height: 45px;
    line-height: 45px;
  }
  .ivu-input-prefix i,
  .ivu-input-suffix i {
    line-height: 45px;
  }
}
.btn-height45 {
  height: 45px;
  line-height: 45px;
  min-width: 80px;
}
</style>
